import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from '@mui/material';

import { AUTHORZIER_TYPES } from './utils';

export default function AuthorizerTypeField({
  value,
  onChange,
  disabled = false,
  variant = 'select',
}) {
  if (variant === 'radio') {
    return (
      <FormControl disabled={disabled}>
        <FormLabel id='authorizer-type-label'>Type</FormLabel>
        <RadioGroup
          row
          aria-labelledby='authorizer-type-label'
          name='authorizer-type'
          value={value || ''}
          onChange={(event) => onChange(event.target.value)}
        >
          <FormControlLabel
            value={AUTHORZIER_TYPES.API_KEY}
            control={<Radio />}
            label='API Key'
          />
          <FormControlLabel
            value={AUTHORZIER_TYPES.OIDC}
            control={<Radio />}
            label='OIDC'
          />
        </RadioGroup>
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id='endpoint-authorizer-type-label'>Authorizer</InputLabel>
      <Select
        labelId='endpoint-authorizer-type-label'
        label='Authorizer'
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={AUTHORZIER_TYPES.NONE}>None</MenuItem>
        <MenuItem value={AUTHORZIER_TYPES.API_KEY}>API Key</MenuItem>
        <MenuItem value={AUTHORZIER_TYPES.OIDC}>OIDC</MenuItem>
      </Select>
    </FormControl>
  );
}
